import axios from '@/utils/axiosRequest'
//获取轮播图
export const photo = (data) => {
  return axios.request({
    url: '/func/photo',
    method: 'POST',
    data
  })
}
//获取职位信息
export const seljoinus = (data) => {
  return axios.request({
    url: '/func/seljoinus',
    method: 'POST',
    data
  })
}
//删除班级人数具体
export const insforum = (data) => {
  return axios.request({
    url: '/weilai/insforum',
    method: 'POST',
    data
  })
}

//回复评论
export const inswrite = (data) => {
  return axios.request({
    url: '/weilai/inswrite',
    method: 'POST',
    data
  })
}

//获取我的信息
export const selecforum = (data) => {
  return axios.request({
    url: '/weilai/selecforum',
    method: 'POST',
    data
  })
}
//获取详细内容
export const onepublic = (data) => {
  return axios.request({
    url: '/note/onepublic',
    method: 'POST',
    data
  })
}
//获取产品列表
export const selproduct = (data) => {
  return axios.request({
    url: '/func/selproduct',
    method: 'POST',
    data
  })
}
//获取资料
export const selectcoll = (data) => {
  return axios.request({
    url: '/weilai/selectcoll',
    method: 'POST',
    data
  })
}
//获取合作企业
export const selectcol = (data) => {
  return axios.request({
    url: '/func/selectcoll',
    method: 'POST',
    data
  })
}
//获取合作企业
export const selectbrief = (data) => {
  return axios.request({
    url: '/weilai/selectbrief',
    method: 'POST',
    data
  })
}
//联系我们
export const insetleaveword = (data) => {
  return axios.request({
    url: '/note/insetleaveword',
    method: 'POST',
    data
  })
}
//获取通知公告
export const selvypublics = (data) => {
  return axios.request({
    url: '/note/selvypublics',
    method: 'POST',
    data
  })
}




